import {useEffect, useRef, useState} from "react";
import SideBar from "../../Layouts/SideBar/SideBar";
import MainContainer from "../../UI/MainContainer";
import SubMainContainer from "../../UI/SubMainContainer";
import Headers from "../../Layouts/Header/Header";
import SearchBar from "../../Layouts/SearchBar/SearchBar";
import CustomerInfo from "../../Customer/CustomerInfo";
import {useLocation} from "react-router-dom";
import AddCustomerPop from "../../Customer/AddCustomerPop";

const Customer = () => {
  const [searchValue, setSearchValue] = useState("");
  const [keyValue, setKeyValue] = useState("");
  const location = useLocation();
  const ref = useRef(true);
  const [message, setMessage] = useState('');
  useEffect(()=>{
    if(ref.current){
      ref.current =  false;
      if(location?.state?.message){
        setMessage(location.state.message);
        window.history.replaceState(null,"");
      }
    }

  },[])

  return (
    <>
      <MainContainer>
        <Headers />
        <SubMainContainer>
          <SideBar />
          <div className="rightCol">
            <div className="contentContainer">
              <h2>Customers</h2>

              <SearchBar
                setSearchValue={setSearchValue}
                setKeyValue={setKeyValue}
                searchValue={searchValue}
                placeholder={"Search customer by name, email, phone"}
                btn_value={"Add New Customer"}
                btn_link={"/addCustomer"}
              />
              <div className="subContent pt-24">
                <CustomerInfo
                  searchValue={searchValue}
                  keyvalue={keyValue}
                  setKeyValue={setKeyValue}
                  setSearchValue={setSearchValue}
                  userType = "C"
                />
                {message && <AddCustomerPop message={message} close={()=>setMessage('')}/>}
              </div>
            </div>
          </div>
        </SubMainContainer>
      </MainContainer>
    </>
  );
};

export default Customer;
